<template>
  <div>
    <el-form ref="formRef" :model="releaseForm" label-width="180px">
      <el-form-item label="发布状态">
        <el-select v-model="anonymity" placeholder="请选择" style="width: 8em;">
          <el-option v-for="item in anonymityArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="昵称：">
        <el-input type="text" placeholder="请输入昵称" v-model="releaseForm.nickName" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="年龄：">
        <el-input placeholder="请输入年龄" v-model="releaseForm.age" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="身高：">
        <el-input placeholder="请输入身高" v-model="releaseForm.height" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="请选择"  style="width: 8em;">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="现居城市：">
        <el-select v-model="province" placeholder="Select" style="width: 11.5em;margin-right: 1em" @change="changeCity" >
          <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="city" placeholder="Select" style="width: 11.5em">
          <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="VIP状态：">
        <el-select v-model="vipState" placeholder="请选择" style="width: 8em;">
          <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布内容：">
        <el-input type="textarea" :rows="4" placeholder="请输入发布内容" v-model="releaseForm.content" size="small" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="捐赠金额：">
        <el-input placeholder="请输入捐赠金额" v-model="releaseForm.donationAmount" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="脱单时间：">
        <el-input placeholder="请输入脱单时间" v-model="releaseForm.cdtctdDuration"  style="width:75%;"  />
      </el-form-item>
      <el-form-item label="脱单圈图片：">
<!--        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">-->
<!--        <div class="add" @click="headImgUpdate" v-else>-->
<!--          <span>+</span>-->
<!--        </div>-->
<!--        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">-->

        <el-space wrap>
          <div class="img-box" v-for="(item, index) in imgArray" :key="item.id">
            <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div class="delIcon" @click="delImg(index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
          </div>
          <div class="add" @click="fileUpdate" v-if="imgArray.length < routeImageNum">
            <span>+</span>
          </div>
        </el-space>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">

      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData, getFormData } from "@/api/api"
import { addOrUpdateSingleRelease,areaList } from "@/api/url";
import { positiveIntReg, negativeDecimal } from "@/assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      releaseForm: this.value.releaseForm,
      idx: this.value.ids,
      loading: false,

      province: this.value.releaseForm.province?this.value.releaseForm.province:'-1',
      city: this.value.releaseForm.city?this.value.releaseForm.city:'-1',
      provinceList: [],
      cityList: [],

      // 发布状态
      anonymityArray: [
        {label: '公开', value: 0},
        {label: '匿名', value: 1}
      ],
      anonymity: this.value.releaseForm.anonymity ? this.value.releaseForm.anonymity : 0,

      // 性别
      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.releaseForm.sex ? this.value.releaseForm.sex : 1,

      // vip状态
      vipStateArray: [
        {label: 'VIP', value: 1},
        {label: '非VIP', value: 0},
      ],
      vipState: this.value.releaseForm.vipState?this.value.releaseForm.vipState:0,

      // files: null,
      // src: this.value.ids > -1?this.value.releaseForm.avatar:'',

      imgArray: this.value.releaseForm.cdtctdCoilImgList?this.value.releaseForm.cdtctdCoilImgList:[],
      routeImageNum: 9,
      delImgIdArray: []

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
      }
    },

    // //更改或添加
    // headImgUpdate() {
    //   this.$refs.headImg.click();
    // },
    //
    // //选取图片
    // headImgChanged(e) {
    //   if(e.target.files[0]) {
    //     this.files = e.target.files[0];
    //     var windowURL = window.URL || window.webkitURL;
    //     this.src = windowURL.createObjectURL(this.files);
    //   }
    // },

    // 删除图片
    delImg(idx) {
      if(this.imgArray[idx].id >= 0) {
        this.delImgIdArray.push(this.imgArray[idx].id);
      }
      this.imgArray.splice(idx,1);
    },


    summit() {
      if(!this.releaseForm.nickName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '昵称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.releaseForm.age) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '年龄不能为空',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.releaseForm.age)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "年龄填正整数",
          type: 'warning'
        });
      }
      if(!this.releaseForm.height) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '身高不能为空',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.releaseForm.height)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "年龄填正整数",
          type: 'warning'
        });
      }
      if(!this.releaseForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '发布内容不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.releaseForm.cdtctdDuration) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '脱单时间不能为空',
          type: 'warning'
        });
        return false
      } else if(!positiveIntReg.test(this.releaseForm.cdtctdDuration)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "脱单时间填非负整数",
          type: 'warning'
        });
      }
      if(this.releaseForm.donationAmount && !negativeDecimal.test(this.releaseForm.donationAmount)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "捐赠金额为非负数，最多精确到两位小数",
          type: 'warning'
        });
      }
      this.loading = true
      let _this = this
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.releaseForm.id);
        param.append('officialId', this.releaseForm.officialId);
      } else {
        param.append('id', 0);
        param.append('officialId', 0);
      }
      param.append('nickName', this.releaseForm.nickName);
      param.append('province', this.province);
      param.append('city', this.city);
      param.append('anonymity', this.anonymity);
      param.append('age', this.releaseForm.age);
      param.append('height', this.releaseForm.height);
      param.append('content', this.releaseForm.content);
      param.append('sex', this.sex);
      param.append('vipState', this.vipState);
      param.append('donationAmount', this.releaseForm.donationAmount);
      param.append('cdtctdDuration', this.releaseForm.cdtctdDuration);
      for(let i = 0; i < this.imgArray.length; i++) {
        if(!this.imgArray[i].id) {
          param.append('file' + i, this.imgArray[i].files);
        }
      }
      param.append('delImgIdArr', this.delImgIdArray.toString());
      imgPostFormData(addOrUpdateSingleRelease, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },

    changeCity() {
      this.cityList = []
      if(this.province == -1) {
        this.cityList.push({label:'不限', value: '-1'})
      }else {
        for(let i=0; i<this.provinceList.length; i++) {
          if (this.province == this.provinceList[i].province) {
            let citys = this.provinceList[i].cityList
            citys.forEach(item => {
              let obj = {}
              obj.label = item.city
              obj.value = item.city
              this.cityList.push(obj)
            })
          }
        }
      }
      this.city = this.cityList[0].value
    },

    getAreaList() {
      getFormData(areaList).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          let dataList = data.data
          dataList.forEach(item => {
            item.label = item.province
            item.value = item.province
          })
          this.provinceList = this.provinceList.concat(dataList);
          if(this.province == -1) {
            this.cityList.push({label:'不限', value: '-1'})
          }else {
            for(let i=0; i<this.provinceList.length; i++) {
              if (this.province == this.provinceList[i].province) {
                let citys = this.provinceList[i].cityList
                citys.forEach(item => {
                  let obj = {}
                  obj.label = item.city
                  obj.value = item.city
                  this.cityList.push(obj)
                })
              }
            }
          }
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

  },
  mounted() {
    this.getAreaList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
